module.exports = __webpack_public_path__ + "static/img/gongzhonghao.09bae64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/gongzhonghao.jpg
// module id = lPO4
// module chunks = 1